import * as yup from 'yup'

import { isPinOk } from '@surglogs-app/util'

export const accountEditPinFormValidator = (PIN_KEYS: string[]) =>
  yup.object().shape({
    password: yup.string().required('isRequired'),
    ...PIN_KEYS.reduce(
      (obj, key) => ({
        ...obj,
        [key]: yup.string().trim().required(),
      }),
      {},
    ),
    pin: yup.string().test('pin', '', function isOk() {
      const currentValue = PIN_KEYS.map((k) => this.parent[k] ?? '').join('')

      return currentValue.length === PIN_KEYS.length
        ? isPinOk(currentValue, PIN_KEYS.length)
        : true
    }),
  })

export type AccountEditPinFormData = {
  password: string
  'pin-0': string
  'pin-1': string
  'pin-2': string
  'pin-3': string
  'pin-4': string
  'pin-5': string
}
